/**
 * Route definition for /chains/monad
 *
 * Renders the shared ChainPage with the `monad` article. Chain facts live in
 * `@/data/chains`; presentation and SEO live in `@/components/ChainPage`.
 *
 * @module routes/chains/monad
 * @category Routes
 */
import { createFileRoute } from '@tanstack/react-router'
import ChainPage from '@/components/ChainPage'

export const Route = createFileRoute('/$locale/chains/monad')({
  component: function MonadChainPage() {
    return <ChainPage slug="monad" />
  },
})
